// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__G7WVy","selected":"styles_selected__1LEQE"};